module.exports = __webpack_public_path__ + "img/35.dc5201b8.svg";